import { isEmpty } from 'lodash';
import { TagOption } from './hooks';

/**
 * Options must be derived using
 * const { options } = useTagOptions(fieldName);
 * or some other method of passing tag options
 * filtered only for a specific fieldName/componentId.
 */
export function getTagOption(value: string, options: TagOption[]): TagOption | undefined {
  if (!isEmpty(options) && !options.every(o => o.fieldName === options[0].fieldName)) {
    throw new Error('All options must have the same fieldName');
  }
  return options.find(o => o.value === value);
}
